export enum WaterfallNetworkID {
  AdMob = "1215381445328257950",
  LiftOff = "1953547073528090325",
  InMobi = "7681903010231960328",
  ChartBoost = "2873236629771172317",
  Pangle = "4069896914521993236",
  Mintegral = "1357746574408896200",
}

export enum BiddingNetworkID {
  LiftOff = "4692500501762622185",
  InMobi = "8468954295581492586",
  Pangle = "3525379893916449117",
  Mintegral = "6250601289653372374",
}
